import type {
  AgentChatStatus,
  AgentDetail,
  AgentRosterEntry,
  AgentUserRow,
  CreateAgentInput,
  UpdateAgentInput,
} from 'types/agents';

async function parseJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const message = await res.text().catch(() => '');
    throw new Error(message || `Request failed with ${res.status}`);
  }
  return res.json() as Promise<T>;
}

const withCreds: RequestInit = { credentials: 'include' };
const jsonBody = (method: string, body: unknown): RequestInit => ({
  method,
  credentials: 'include',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export async function getAgentRoster(): Promise<AgentRosterEntry[]> {
  return parseJson(await fetch('/api/agents', withCreds));
}

export async function getAgentUsers(): Promise<AgentUserRow[]> {
  return parseJson(await fetch('/api/agents/users', withCreds));
}

export async function getMyAgent(): Promise<AgentRosterEntry | null> {
  return parseJson(await fetch('/api/agents/me', withCreds));
}

export async function getAgentDetail(userId: string): Promise<AgentDetail> {
  return parseJson(await fetch(`/api/agents/${userId}`, withCreds));
}

export async function createAgent(input: CreateAgentInput): Promise<{ success: boolean }> {
  return parseJson(await fetch('/api/agents', jsonBody('POST', input)));
}

export async function updateAgent(
  userId: string,
  patch: UpdateAgentInput,
): Promise<{ success: boolean }> {
  return parseJson(await fetch(`/api/agents/${userId}`, jsonBody('PATCH', patch)));
}

export async function deleteAgent(userId: string): Promise<{ success: boolean }> {
  return parseJson(
    await fetch(`/api/agents/${userId}`, { method: 'DELETE', credentials: 'include' }),
  );
}

export async function setMyChatStatus(chatStatus: AgentChatStatus): Promise<{ success: boolean }> {
  return parseJson(await fetch('/api/agents/me/status', jsonBody('POST', { chatStatus })));
}
